(function () {
  "use strict";

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  }
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + d.toUTCString() + ";path=/";
  }

  function pickWeightedIndex(slices) {
    const total = slices.reduce((sum, s) => sum + (Number(s.probability) || 0), 0);
    if (total <= 0) return Math.floor(Math.random() * slices.length);
    let r = Math.random() * total;
    for (let i = 0; i < slices.length; i++) {
      r -= Number(slices[i].probability) || 0;
      if (r <= 0) return i;
    }
    return slices.length - 1;
  }

  function launchConfetti(canvas) {
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const colors = ["#f39c12", "#e67e22", "#27ae60", "#1b4d3e", "#e74c3c", "#3498db", "#f1c40f"];
    const pieces = [];
    const count = 160;
    for (let i = 0; i < count; i++) {
      pieces.push({
        x: Math.random() * canvas.width,
        y: -20 - Math.random() * canvas.height * 0.5,
        w: 6 + Math.random() * 6,
        h: 8 + Math.random() * 10,
        color: colors[Math.floor(Math.random() * colors.length)],
        rot: Math.random() * 360,
        rotSpeed: (Math.random() - 0.5) * 10,
        vy: 2 + Math.random() * 3,
        vx: (Math.random() - 0.5) * 2,
        opacity: 1
      });
    }
    let frame = 0;
    const maxFrames = 260;
    function draw() {
      frame++;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      pieces.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.rotSpeed;
        if (frame > maxFrames - 60) p.opacity = Math.max(0, p.opacity - 0.02);
        ctx.save();
        ctx.globalAlpha = p.opacity;
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rot * Math.PI) / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (frame < maxFrames) {
        requestAnimationFrame(draw);
      } else {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    }
    draw();
  }

  function playSound(url) {
    if (!url) return;
    try {
      const audio = new Audio(url);
      audio.volume = 0.6;
      audio.play().catch(() => {});
    } catch (e) {}
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  // A slice wins when it has a code, or when it is a prize without a code
  // (e.g. a free gift that adds itself to the cart).
  function isLosingSlice(slice) {
    return slice.isLosingSlice || (!slice.discountCode && !slice.noCode);
  }

  function escapeHtml(str) {
    const div = document.createElement("div");
    div.textContent = str == null ? "" : String(str);
    return div.innerHTML;
  }

  function initWheel(sectionId) {
    const config = window.SpinWheelConfig && window.SpinWheelConfig[sectionId];
    if (!config) return;

    const wrapper = document.getElementById("spinWheelSection-" + sectionId);
    const wheelInner = document.getElementById("shopifyWheel-" + sectionId);
    const outerBorder = wheelInner ? wheelInner.closest(".wheel-outer-border") : null;
    const pointer = wrapper ? wrapper.querySelector(".wheel-pointer") : null;
    const form = document.getElementById("spinCustomerForm-" + sectionId);
    const submitBtn = document.getElementById("spinWheelBtn-form-" + sectionId);
    const closeBtn = wrapper ? wrapper.querySelector(".spin-wheel-close") : null;
    const noThanksBtn = wrapper ? wrapper.querySelector(".spin-no-thanks") : null;
    const contentArea = document.getElementById("spinContentArea-" + sectionId);
    const emailError = document.getElementById("spinEmailError-" + sectionId);
    const confettiCanvas = document.getElementById("spinConfetti-" + sectionId);

    if (!wrapper || !wheelInner || !form || !submitBtn) return;

    const slices = config.slices.filter((s) => s.title);
    if (!slices.length) return;

    // Re-parent to <body> so position:fixed resolves against the viewport,
    // not against #main-content (which some themes clip/transform). In the
    // theme editor a re-rendered section leaves the old copies on <body>.
    const launcher = document.getElementById("spinWheelLauncher-" + sectionId);
    [wrapper, launcher].forEach((el) => {
      if (!el) return;
      document.querySelectorAll("body > #" + el.id).forEach((old) => { if (old !== el) old.remove(); });
      if (el.parentElement !== document.body) document.body.appendChild(el);
    });

    const closedKey = "spinWheelClosed_" + sectionId;
    const attemptsKey = "spinWheelAttempts_" + sectionId;
    const sessionKey = "spinWheelSessionShown_" + sectionId;

    function attemptsUsed() {
      return parseInt(getCookie(attemptsKey) || "0", 10);
    }
    function hasAttemptsLeft() {
      return !!config.unlimitedSpins || attemptsUsed() < (config.maxAttempts || 1);
    }
    function wasRecentlyClosed() {
      return !!getCookie(closedKey);
    }
    function shownThisSession() {
      return config.showOncePerSession && sessionStorage.getItem(sessionKey);
    }

    // The result is shown in its own box while the form is only hidden (not
    // replaced), so its listeners survive and the wheel can be spun again.
    const contentInner = contentArea ? contentArea.querySelector(".spin-wheel-content-inner") : null;
    let resultBox = null;
    function showResult(html) {
      if (resultBox) resultBox.remove();
      resultBox = document.createElement("div");
      resultBox.className = "spin-result-box";
      resultBox.innerHTML = html;
      if (contentInner) contentInner.style.display = "none";
      contentArea.appendChild(resultBox);
    }
    function resetToForm() {
      if (resultBox) { resultBox.remove(); resultBox = null; }
      if (contentInner) contentInner.style.display = "";
      submitBtn.disabled = false;
      const btnText = submitBtn.querySelector(".btn-text");
      const btnSpinner = submitBtn.querySelector(".btn-spinner");
      if (btnText) btnText.style.display = "";
      if (btnSpinner) btnSpinner.style.display = "none";
    }

    function openModal() {
      if (!hasAttemptsLeft()) return;
      // Reopened after a spin (e.g. from the floating icon): back to a fresh spin
      if (resultBox && !isSpinning) resetToForm();
      wrapper.style.display = "flex";
      layoutWheel(); // wheel now has a real size
      if (config.showOncePerSession) sessionStorage.setItem(sessionKey, "true");
      updateLauncher();
    }
    function closeModal(persist) {
      wrapper.style.display = "none";
      if (persist) setCookie(closedKey, "true", config.cookieExpiryDays || 30);
      updateLauncher();
    }

    // Floating wheel icon: opens the wheel on click (even after the popup was
    // closed), hides while the popup is open, once every spin is used, or for
    // the rest of the visit after its own close button.
    const launcherHiddenKey = "spinWheelLauncherHidden_" + sectionId;
    function launcherDismissed() {
      try { return !!sessionStorage.getItem(launcherHiddenKey); } catch (e) { return false; }
    }
    function updateLauncher() {
      if (!launcher) return;
      const isOpen = wrapper.style.display === "flex";
      const editor = window.Shopify && window.Shopify.designMode;
      const wasHidden = launcher.hidden;
      launcher.hidden = isOpen || (!editor && (!hasAttemptsLeft() || launcherDismissed()));
      if (wasHidden && !launcher.hidden && typeof placeAboveChat === "function") placeAboveChat();
    }
    // Chat widgets (Shopify Inbox's <shopify-chat> is a full-screen layer on top
    // of everything) swallow clicks where they overlap the icon. Probe the
    // column under the icon from the bottom up and lift the icon above the
    // highest chat hit. Re-run while the chat script loads and on resize.
    function isChatElement(el) {
      if (!el || el === document.documentElement || el === document.body) return false;
      if (el.tagName === "SHOPIFY-CHAT") return true;
      const label = (el.id || "") + " " + (typeof el.className === "string" ? el.className : "") + " " + (el.getAttribute("title") || "");
      return /chat|inbox|gorgias|tidio|zendesk|intercom|crisp/i.test(label);
    }
    function placeAboveChat() {
      if (!launcher || !config.launcherAvoidChat || launcher.hidden) return;
      launcher.style.bottom = "";
      const rect = launcher.getBoundingClientRect();
      if (!rect.width) return;
      const base = parseFloat(getComputedStyle(launcher).bottom) || 0;
      const xs = [rect.left + rect.width * 0.2, rect.left + rect.width / 2, rect.right - rect.width * 0.2];
      launcher.style.visibility = "hidden"; // let elementFromPoint see what is underneath
      let chatTop = -1;
      for (let dy = 0; dy <= 320; dy += 6) {
        const y = window.innerHeight - 1 - dy;
        if (xs.some((x) => isChatElement(document.elementFromPoint(x, y)))) chatTop = dy;
      }
      launcher.style.visibility = "";
      if (chatTop >= 0 && base < chatTop + 14) launcher.style.bottom = (chatTop + 14) + "px";
    }

    if (launcher) {
      const launcherBtn = launcher.querySelector(".spin-launcher__btn");
      const launcherClose = launcher.querySelector(".spin-launcher__close");
      if (launcherBtn) launcherBtn.addEventListener("click", () => openModal());
      if (launcherClose) {
        launcherClose.addEventListener("click", () => {
          try { sessionStorage.setItem(launcherHiddenKey, "1"); } catch (e) {}
          launcher.hidden = true;
        });
      }
      updateLauncher();
      if (config.launcherAvoidChat) {
        [600, 2000, 4500, 9000].forEach((ms) => setTimeout(placeAboveChat, ms));
        let resizeTimer = null;
        window.addEventListener("resize", () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(placeAboveChat, 250);
        });
      }
    }

    // Auto-open after the delay OR once the visitor scrolls past
    // scrollTriggerPercent of the page, whichever comes first. The gate makes
    // sure only the first trigger opens it, so a later one can't re-open a
    // popup the visitor already closed.
    if (!wasRecentlyClosed() && hasAttemptsLeft() && !shownThisSession()) {
      let autoOpened = false;
      let openTimer = null;
      const scrollPercent = Number(config.scrollTriggerPercent) || 0;
      const onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && window.scrollY / scrollable >= scrollPercent / 100) autoOpen();
      };
      const autoOpen = () => {
        if (autoOpened) return;
        autoOpened = true;
        clearTimeout(openTimer);
        window.removeEventListener("scroll", onScroll);
        openModal();
      };
      if (config.autoOpenDelay > 0 || !scrollPercent) openTimer = setTimeout(autoOpen, config.autoOpenDelay || 0);
      if (scrollPercent > 0) {
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll(); // already scrolled past it (e.g. reload mid-page)
      }
    }

    if (config.triggerOnExitIntent) {
      let exitTriggered = false;
      document.addEventListener("mouseout", function (e) {
        if (exitTriggered || wrapper.style.display === "flex") return;
        if (!e.relatedTarget && e.clientY < 10 && !wasRecentlyClosed() && hasAttemptsLeft()) {
          exitTriggered = true;
          openModal();
        }
      });
    }

    if (closeBtn) closeBtn.addEventListener("click", () => closeModal(true));
    if (noThanksBtn) noThanksBtn.addEventListener("click", () => closeModal(true));
    const overlayEl = wrapper.querySelector(".spin-wheel-overlay");
    if (overlayEl) {
      overlayEl.addEventListener("click", function (e) {
        if (e.target === this) closeModal(true);
      });
    }

    // Thin light seam between every slice (including wrap-around) so
    // segments read as distinct pieces instead of bleeding together.
    const sliceAngle = 360 / slices.length;
    // "scheme" mode alternates the color scheme's slice colors (CSS variables
    // from spin-wheel.css); an odd count gets a third color on the last slice
    // so it never matches its neighbour across the wrap-around.
    if (config.sliceColorMode !== "custom") {
      slices.forEach((slice, i) => {
        const key = slices.length > 1 && slices.length % 2 === 1 && i === slices.length - 1 ? "c" : i % 2 ? "b" : "a";
        slice.color = "var(--sw-slice-" + key + ")";
        slice.textColor = "var(--sw-slice-" + key + "-text)";
      });
    }
    const dividerColor = "var(--sw-divider, rgba(255,255,255,0.55))";
    const seam = Math.min(1, sliceAngle * 0.1);
    const half = seam / 2;
    const gradientStops = [dividerColor + " 0deg " + half + "deg"];
    slices.forEach((slice, i) => {
      const segStart = i * sliceAngle + half;
      const segEnd = (i + 1) * sliceAngle - half;
      gradientStops.push(slice.color + " " + segStart + "deg " + segEnd + "deg");
      const boundary = (i + 1) * sliceAngle;
      if (i < slices.length - 1) {
        gradientStops.push(dividerColor + " " + (boundary - half) + "deg " + (boundary + half) + "deg");
      }
    });
    gradientStops.push(dividerColor + " " + (360 - half) + "deg 360deg");
    wheelInner.style.background = "conic-gradient(" + gradientStops.join(", ") + ")";

    let currentRotation = 0;
    let isSpinning = false;

    // ---------------------------------------------------------
    // SLICE LABELS: polar-coordinate layout
    // ---------------------------------------------------------
    // Every label is centred on its slice's bisector at one shared radius,
    // with its text running along the radius (centre -> rim). All geometry is
    // derived from the wheel's *rendered* size, so it adapts to slice count
    // and breakpoints. layoutLabels() is the only place label geometry is set;
    // CSS just applies the custom properties it writes.
    const LABEL_LINE_HEIGHT = 1.15; // keep in sync with .wheel-slice-label
    const LABEL_MIN_FONT = 7;
    const LABEL_MAX_FONT = 22;
    const LABEL_MAX_LINES = 3;
    const hub = wrapper.querySelector(".wheel-center-hub");

    // Map labels by block index: blank-title blocks are filtered out of
    // `slices`, so DOM order and slice order can differ.
    const labelEls = slices.map((s) => wheelInner.querySelector('.wheel-slice-label[data-index="' + s.id + '"]'));
    wheelInner.querySelectorAll(".wheel-slice-label").forEach((el) => {
      if (labelEls.indexOf(el) === -1) el.style.display = "none";
    });
    labelEls.forEach((label, i) => {
      const span = label && label.querySelector("span");
      if (span) span.style.color = slices[i].textColor || "#fff";
    });

    // Rim lights sit on the (non-rotating) border ring, evenly spaced,
    // skipping 3 o'clock where the pointer is.
    const BULB_COUNT = 16;
    const bulbs = [];
    if (config.rimLights && outerBorder) {
      for (let i = 0; i < BULB_COUNT; i++) {
        if (i === BULB_COUNT / 4) continue;
        const el = document.createElement("span");
        el.className = "wheel-bulb" + (i % 2 ? " wheel-bulb--alt" : "");
        outerBorder.insertBefore(el, wheelInner);
        bulbs.push({ el: el, angle: (i * 360) / BULB_COUNT });
      }
    }
    function layoutBulbs() {
      const inner = outerBorder ? outerBorder.clientWidth : 0;
      if (!bulbs.length || !inner) return;
      const ring = (outerBorder.offsetWidth - inner) / 2; // border width
      const r = inner / 2 + ring / 2; // middle of the border ring
      const size = Math.max(4, Math.min(8, ring * 0.55));
      bulbs.forEach((b) => {
        const rad = ((b.angle - 90) * Math.PI) / 180;
        b.el.style.left = (inner / 2 + Math.cos(rad) * r).toFixed(2) + "px";
        b.el.style.top = (inner / 2 + Math.sin(rad) * r).toFixed(2) + "px";
        b.el.style.width = b.el.style.height = size + "px";
      });
    }
    function layoutWheel() {
      layoutBulbs();
      layoutLabels();
    }

    function layoutLabels(animate) {
      // clientWidth ignores transforms (spin rotation, pop-in scale), unlike
      // getBoundingClientRect. It is 0 while the popup is display:none.
      const R = wheelInner.clientWidth / 2;
      if (!R) return;

      const n = slices.length;
      const halfRad = Math.PI / n; // half of one slice's angle
      const narrow = n > 2; // for 1-2 slices the "wedge" is a half-plane or more
      const hubR = hub ? hub.offsetWidth / 2 : R * 0.2;

      // Base size scales with the wheel and shrinks as slices get narrower:
      // ~20px @ 4, ~19 @ 5, ~18 @ 6, ~16 @ 8, ~15 @ 10 slices on a 320px disc (shrinks to fit).
      let fontSize = Math.min(LABEL_MAX_FONT, Math.max(10, R * 0.13 * Math.pow(4 / Math.max(n, 4), 0.4)));

      // Clearance from the rim. Any slice can come to rest at the pointer,
      // whose tip reaches into the disc, so clear that too (layout offsets
      // are unaffected by the pointer's bounce transform).
      const pointerDepth = pointer ? Math.min(R * 0.25, Math.max(0, wheelInner.offsetLeft + wheelInner.offsetWidth - pointer.offsetLeft)) : 0;
      const edgePad = Math.max(5, R * 0.06, pointerDepth + 2);
      const sidePad = 3; // clearance from the slice dividers
      const hubClear = hubR + 4 + Math.max(4, R * 0.05); // hub + its 4px ring + gap

      // Largest half-thickness a label can have at distance x along the
      // bisector while staying sidePad away from both dividers.
      const halfWidthAt = (x) => (narrow ? x * Math.tan(halfRad) - sidePad / Math.cos(halfRad) : Infinity);

      // Inner edge of the text band. On narrow slices, push it outward until
      // two lines fit between the dividers (capped so the band stays usable).
      let inner = hubClear;
      if (narrow) {
        const twoLinesInner = (fontSize * LABEL_LINE_HEIGHT + sidePad / Math.cos(halfRad)) / Math.tan(halfRad);
        inner = Math.max(inner, Math.min(twoLinesInner, R * 0.45));
      }
      const halfThick = Math.max(0, Math.min(halfWidthAt(inner), R * 0.3));
      // Outer corners of the label box must stay edgePad inside the rim.
      const outer = Math.sqrt(Math.max(0, Math.pow(R - edgePad, 2) - halfThick * halfThick));
      const length = Math.max(0, outer - inner); // text line length (along the radius)
      const radius = (inner + outer) / 2; // shared distance of every label centre

      // Shrink one shared font size until every label fits its box, so all
      // slices keep identical typography.
      wheelInner.style.setProperty("--label-length", length.toFixed(2) + "px");
      wheelInner.classList.add("is-measuring");
      const fitsAll = (size) => {
        const maxHeight = Math.min(halfThick * 2, LABEL_MAX_LINES * size * LABEL_LINE_HEIGHT) + 0.5;
        return labelEls.every((label) => {
          const span = label && label.querySelector("span");
          return !span || (span.scrollWidth <= span.clientWidth && span.offsetHeight <= maxHeight);
        });
      };
      for (;;) {
        wheelInner.style.setProperty("--label-font-size", fontSize + "px");
        if (fontSize <= LABEL_MIN_FONT || fitsAll(fontSize)) break;
        fontSize = Math.max(LABEL_MIN_FONT, fontSize - 0.5);
      }
      const fitted = fitsAll(fontSize);
      wheelInner.classList.remove("is-measuring");

      // Last-resort clamp (ellipsis) so text can never cross a divider.
      const lines = Math.max(1, Math.min(LABEL_MAX_LINES, Math.floor((halfThick * 2 + 0.5) / (fontSize * LABEL_LINE_HEIGHT))));
      wheelInner.style.setProperty("--label-lines", String(lines));
      if (!fitted && window.Shopify && window.Shopify.designMode) {
        console.warn("Spin wheel: some slice labels are too long for " + n + " slices at this wheel size and were truncated. Consider shorter slice text.");
      }

      // Animate only the post-spin flip; initial and resize layouts snap.
      wheelInner.classList.toggle("labels-animate", !!animate);

      labelEls.forEach((label, i) => {
        if (!label) return;
        // Slice midpoint, measured clockwise from 12 o'clock: the same frame
        // as the conic-gradient and the spin/pointer maths.
        const midAngle = sliceAngle * i + sliceAngle / 2;
        // Screen-space polar angle (0 = 3 o'clock, clockwise, y down).
        const theta = midAngle - 90;
        const rad = (theta * Math.PI) / 180;
        const x = Math.cos(rad) * radius;
        const y = Math.sin(rad) * radius;
        // Rotating by theta makes the text run outward along the radius. Flip
        // it 180deg about its own centre when, at the wheel's current resting
        // angle, it would read right-to-left (upside down).
        const onScreen = (((theta + currentRotation) % 360) + 360) % 360;
        const flip = onScreen > 90.01 && onScreen < 269.99;
        label.style.setProperty("--label-x", x.toFixed(2) + "px");
        label.style.setProperty("--label-y", y.toFixed(2) + "px");
        label.style.setProperty("--label-rot", (theta + (flip ? 180 : 0)) + "deg");
      });

      wheelInner.classList.add("labels-ready");
    }

    layoutWheel();
    if (typeof ResizeObserver === "function") {
      // Fires when the popup opens (0 -> real size) and on every breakpoint change.
      new ResizeObserver(() => layoutWheel()).observe(wheelInner);
    } else {
      window.addEventListener("resize", () => layoutWheel());
    }
    // Web fonts change text metrics; re-fit once they are ready.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => layoutLabels());

    function buildResultPanel(winningSlice) {
      const isLoss = isLosingSlice(winningSlice);
      const code = winningSlice.noCode ? "" : winningSlice.discountCode;
      const parts = ['<div class="spin-result-panel">'];

      // Win/lose artwork, pre-rendered by Liquid in <template> tags (sections/spin-the-wheel.liquid).
      const artTemplate = wrapper.querySelector('template[data-result-art="' + (isLoss ? "lose" : "win") + '"]');
      if (artTemplate) parts.push(artTemplate.innerHTML);

      if (isLoss) {
        parts.push("<h2>" + escapeHtml(config.losingHeading) + "</h2>");
        parts.push('<p class="spin-result-sub">' + escapeHtml(config.losingSubtext) + "</p>");
      } else {
        const message = (winningSlice.message || config.winningSubtextTemplate)
          .replace(/%code%/g, code)
          .replace(/%prize%/g, winningSlice.title);
        parts.push("<h2>" + escapeHtml(config.resultHeading) + "</h2>");
        parts.push('<p class="spin-result-sub">' + escapeHtml(message) + "</p>");
        if (code) {
          parts.push('<div class="spin-code-box">');
          parts.push('<span class="spin-code-value">' + escapeHtml(code) + "</span>");
          parts.push('<button type="button" class="spin-copy-btn" data-code="' + escapeHtml(code) + '">' + escapeHtml(config.copyButtonText) + "</button>");
          parts.push("</div>");
        }
      }

      // A slice's own link/text win over the section's Post-win CTA. The
      // discount redirect only takes store paths, so an outside link is used as-is.
      let targetUrl = winningSlice.link || config.shopCtaUrl || "/collections/all";
      try {
        // A full link to this store (https://getaniwell.com/pages/...) becomes a path so the code can still be applied
        const parsed = new URL(targetUrl, window.location.origin);
        const host = parsed.host.replace(/^www\./, "");
        if (host === window.location.host.replace(/^www\./, "")) targetUrl = parsed.pathname + parsed.search + parsed.hash;
      } catch (e) {}
      const ctaUrl = !isLoss && code && winningSlice.autoApply && targetUrl.charAt(0) === "/"
        ? "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(targetUrl)
        : targetUrl;
      const ctaText = winningSlice.linkText || config.shopCtaText;

      parts.push('<a href="' + escapeHtml(ctaUrl) + '" class="spin-shop-cta">' + escapeHtml(ctaText) + "</a>");
      if (hasAttemptsLeft()) parts.push('<button type="button" class="spin-again-btn">' + escapeHtml(config.spinAgainText || "Spin again") + "</button>");
      if (!config.unlimitedSpins) parts.push('<p class="spin-attempts-used">' + attemptsUsed() + " / " + (config.maxAttempts || 1) + " spins used</p>");
      parts.push("</div>");
      return parts.join("");
    }

    function attachCopyHandler() {
      const copyBtn = contentArea.querySelector(".spin-copy-btn");
      if (!copyBtn) return;
      copyBtn.addEventListener("click", function () {
        const code = this.getAttribute("data-code");
        const finish = () => {
          this.textContent = config.copiedButtonText;
          this.classList.add("copied");
          setTimeout(() => {
            this.textContent = config.copyButtonText;
            this.classList.remove("copied");
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(finish).catch(finish);
        } else {
          const temp = document.createElement("textarea");
          temp.value = code;
          document.body.appendChild(temp);
          temp.select();
          try { document.execCommand("copy"); } catch (e) {}
          document.body.removeChild(temp);
          finish();
        }
      });
    }

    function setFieldError(message) {
      if (emailError) emailError.textContent = message || "";
      const emailInput = form.querySelector("input[name='contact[email]']");
      if (emailInput) emailInput.classList.toggle("spin-input-error", !!message);
    }

    const consentInput = document.getElementById("spinConsent-" + sectionId);
    const consentError = document.getElementById("spinConsentError-" + sectionId);
    function setConsentError(message) {
      if (consentError) consentError.textContent = message || "";
    }
    if (consentInput) consentInput.addEventListener("change", () => setConsentError(""));

    function doSpin() {
      if (isSpinning || !hasAttemptsLeft()) return;
      isSpinning = true;

      const winningIndex = pickWeightedIndex(slices);
      const winningSlice = slices[winningIndex];

      // The pointer marks the 3 o'clock position (90deg from the wheel's
      // own 0deg-at-top reference), not the top. The wheel must land with
      // the winning slice's mid-angle rotated to 90deg.
      const pointerAngle = 90;
      const targetMidAngle = sliceAngle * winningIndex + sliceAngle / 2;
      const fullRotations = (config.minRotations || 5) * 360;
      const currentMod = ((currentRotation % 360) + 360) % 360;
      const requiredMod = ((pointerAngle - targetMidAngle) % 360 + 360) % 360;
      const delta = ((requiredMod - currentMod) % 360 + 360) % 360;
      const finalRotation = currentRotation + fullRotations + delta;
      currentRotation = finalRotation;

      if (outerBorder) outerBorder.classList.add("is-spinning");
      wheelInner.style.transition = "transform " + ((config.spinDurationMs || 5000) / 1000) + "s cubic-bezier(0.12, 0.72, 0.15, 1)";
      wheelInner.style.transform = "rotate(" + finalRotation + "deg)";

      if (config.enableSound && config.spinSoundUrl) playSound(config.spinSoundUrl);

      const tickInterval = setInterval(() => {
        if (pointer) {
          pointer.classList.add("is-bouncing");
          setTimeout(() => pointer.classList.remove("is-bouncing"), 150);
        }
      }, 180);

      setTimeout(() => {
        clearInterval(tickInterval);
        if (outerBorder) outerBorder.classList.remove("is-spinning");
        layoutLabels(true); // re-flip labels for the wheel's resting angle

        const attempts = attemptsUsed() + 1;
        setCookie(attemptsKey, String(attempts), 365);

        const isLoss = isLosingSlice(winningSlice);
        if (!isLoss) {
          if (config.enableConfetti && confettiCanvas) launchConfetti(confettiCanvas);
          if (config.enableSound && config.winSoundUrl) playSound(config.winSoundUrl);
        }

        showResult(buildResultPanel(winningSlice));
        attachCopyHandler();
        const againBtn = resultBox.querySelector(".spin-again-btn");
        if (againBtn) againBtn.addEventListener("click", () => {
          resetToForm();
          submitBtn.focus();
        });

        setCookie(closedKey, "true", config.cookieExpiryDays || 30);
        isSpinning = false;
      }, config.spinDurationMs || 5000);
    }

    submitBtn.addEventListener("click", function (e) {
      e.preventDefault();
      const emailInput = form.querySelector("input[name='contact[email]']");
      const email = emailInput ? emailInput.value.trim() : "";

      if (!email) {
        setFieldError("Please enter your email address.");
        emailInput.focus();
        return;
      }
      if (!isValidEmail(email)) {
        setFieldError("Please enter a valid email address.");
        emailInput.focus();
        return;
      }
      setFieldError("");

      // This click handler bypasses native `required` validation, so the
      // consent box must be enforced here. Its checked value is what sends
      // contact[accepts_marketing] to Shopify.
      if (consentInput && !consentInput.checked) {
        setConsentError("Please tick the box to agree before spinning.");
        consentInput.focus();
        return;
      }
      setConsentError("");

      if (!hasAttemptsLeft()) {
        setFieldError("You've already used all your spins.");
        return;
      }

      submitBtn.disabled = true;
      const btnText = submitBtn.querySelector(".btn-text");
      const btnSpinner = submitBtn.querySelector(".btn-spinner");
      if (btnText) btnText.style.display = "none";
      if (btnSpinner) btnSpinner.style.display = "inline-block";

      // Sign the email up once; repeat spins with the same email skip the
      // form post (and Shopify's captcha).
      const signedUpKey = "spinWheelSignedUp_" + sectionId;
      let signedUpEmail = "";
      try { signedUpEmail = localStorage.getItem(signedUpKey) || ""; } catch (err) {}
      if (signedUpEmail !== email.toLowerCase()) {
        submitSignup();
        try { localStorage.setItem(signedUpKey, email.toLowerCase()); } catch (err) {}
      }
      doSpin();
    });

    // Shopify protects customer forms with hCaptcha, and its script only adds
    // the captcha token during a real form submission; a fetch() POST has no
    // token and is rejected. So the form is submitted natively (Shopify's
    // captcha runs exactly as on a normal newsletter form) into a hidden
    // iframe, which keeps the popup and spin on screen. Shopify redirects a
    // saved signup to "...?customer_posted=true".
    const signupFrame = document.createElement("iframe");
    signupFrame.name = "spinSignupFrame-" + sectionId;
    signupFrame.title = "Newsletter signup";
    signupFrame.tabIndex = -1;
    signupFrame.setAttribute("aria-hidden", "true");
    signupFrame.style.cssText = "position:absolute;width:0;height:0;border:0;visibility:hidden;";
    wrapper.appendChild(signupFrame);
    form.target = signupFrame.name;
    let signupPending = false;

    function submitSignup() {
      signupPending = true;
      const finish = (state, url) => {
        clearTimeout(timeout);
        signupFrame.onload = null;
        signupPending = false;
        wrapper.setAttribute("data-signup", state);
        if (state !== "saved") console.warn("Spin wheel: Shopify did not confirm the signup (" + (url || "no response") + ")");
        signupFrame.src = "about:blank"; // stop the loaded storefront page's scripts
      };
      const timeout = setTimeout(() => finish("unconfirmed"), 20000);
      signupFrame.onload = () => {
        let url = "";
        try { url = signupFrame.contentWindow.location.href; } catch (e) {}
        if (!url || url === "about:blank") return;
        finish(/[?&]customer_posted=true/.test(url) ? "saved" : "unconfirmed", url);
      };
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else if (form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }))) {
        form.submit(); // old browsers: nothing intercepted the event, submit directly
      }
    }

    form.addEventListener("submit", function (e) {
      if (signupPending) return; // our own submission: let Shopify's captcha handle it
      // Enter key in the email field: run the same validation + spin as the
      // button. Deferred because browsers ignore a new submission started
      // while this submit event is still being dispatched.
      e.preventDefault();
      e.stopPropagation();
      setTimeout(() => submitBtn.click(), 0);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (!window.SpinWheelConfig) return;
    Object.keys(window.SpinWheelConfig).forEach(initWheel);
  });

  document.addEventListener("shopify:section:load", function (event) {
    const section = event.target.querySelector("[id^='spinWheelSection-']");
    if (section) {
      const id = section.id.replace("spinWheelSection-", "");
      initWheel(id);
    }
  });
})();